// Brand constants and shared content for Dead Bug Edwards
export const BRAND = {
  name: "Dead Bug Edwards",
  tagline: "The Termite Company",
  since: 1959,
  yearsOfService: "Over 65 Years of Service",
  phoneDisplay: "1-800-DEAD BUG",
  phoneTel: "1-800-332-3284",
  officePhoneDisplay: "(954) 581-9200",
  officePhoneTel: "954-581-9200",
  email: "info@deadbugedwards.net",
  address: {
    line1: "300 S State Road 7",
    city: "Plantation",
    state: "FL",
    zip: "33317",
  },
  hours: "Mon - Fri: 8:00 AM - 5:00 PM",
  logo: "https://customer-assets.emergentagent.com/job_deadbug-leads/artifacts/a2dva2pd_logo-3.webp",
  badge65: "https://customer-assets.emergentagent.com/job_deadbug-leads/artifacts/vuf1kmo9_unnamed.webp",
  heroVideo: "https://customer-assets.emergentagent.com/job_deadbug-leads/artifacts/c8v9oexi_3401947671-preview.mp4",
  heroImage: "https://customer-assets-cm19k8pv.emergentagent.net/job_deadbug-leads/artifacts/y6gydevs_DBE.jpg",
  since1959Ribbon: "https://customer-assets-cm19k8pv.emergentagent.net/job_deadbug-leads/artifacts/qervc02j_banner-since-1959.png",
  ownerPortrait: "https://customer-assets-cm19k8pv.emergentagent.net/job_deadbug-leads/artifacts/7vujns9f_new-photo.jpg",
};

export const SERVICES = [
  {
    slug: "termite",
    icon: "fa-bug",
    title: "Termite Control",
    tag: "Our Specialty",
    blurb: "South Florida's #1 termite experts. Tent fumigation, liquid & localized treatments - backed by our 65-year guarantee.",
    img: "https://customer-assets.emergentagent.com/job_deadbug-leads/artifacts/422wqshj_pexels-jimbear-12895278.jpg",
    heroHeadline: "Termite Control",
    heroSub: "Proven Results. Over 65 Years. Backed by the company South Florida trusts.",
    intro: "You love your home. So you can see why pests might be attracted to it, too. And if they're termites, the results can be catastrophic. It's estimated that termites and other similar wood-destroying pests wreak havoc on U.S. buildings and crops to the tune of about $30 billion per year, with the average homeowner swallowing about $3,000 of that. These insects snack 24/7 and some species can lay up to 40,000 eggs per day. So it's important to catch them early.",
    sections: [
      {
        title: "Signs of an Infestation - Time for an Inspection",
        text: "Even if your home is built with brick or vinyl, termites can bypass the exterior to enter and feed on ceilings, floors, cabinets, furniture - and even cardboard boxes or canvases. Signs of termite damage include wood that has buckled or is swollen, or you may even see the wooden tunnels the termites have burrowed. You might also find mud tubes that connect their underground nest to a structure. Or even droppings, which look like tiny wood-colored pellets. Often, you'll detect a moldy scent as well. If so, it's time to call Dead Bug Edwards for a termite inspection.",
      },
      {
        title: "The Dead Bug Edwards Approach",
        text: "Dead Bug Edwards can identify and guide you through the best options to eliminate your termite issues and protect your home. From structural fumigation to localized treatments and preventative measures, rely on the company with over 65 years of providing termite control in South Florida.",
      },
      {
        title: "Never Have Termites Over for Dinner Again",
        text: "Call Dead Bug Edwards today for a free inspection of your home for an estimate to protect your home against these destroyers. No need to put up with pests - put them to rest with Dead Bug Edwards.",
      },
    ],
    bullets: [
      "Structural tent fumigation",
      "Localized spot treatments",
      "Liquid soil barriers",
      "Bait station monitoring",
      "New-construction preventative treatments",
      "Real estate inspection letters (WDO)",
    ],
  },
  {
    slug: "pest-control",
    icon: "fa-house-chimney",
    title: "Pest Control",
    tag: "Homes & Properties",
    blurb: "Quarterly plans that keep ants, roaches, spiders & more out of your home - pet-safe, family-first.",
    img: "https://customer-assets-cm19k8pv.emergentagent.net/job_deadbug-leads/artifacts/3w95nz0z_pexels-chris-the-island-3570397-32270941.webp",
    heroHeadline: "Pest Control",
    heroSub: "Your home should be a haven - not a hideout for pests.",
    intro: "Nobody likes the thought of roaches, ants, silverfish, etc. invading their home. Our pest control process is simple. Friendly, trained and licensed service technicians perform a thorough inspection of your home and yard to uncover potential issues. We know where termites, spiders, rodents, ants and other pests like to live and lurk - so we'll pinpoint these places.",
    sections: [
      {
        title: "Custom-Built Treatment Programs",
        text: "Then we'll provide you with a fully customized program to treat and eliminate entry points and nests. We treat inside and outside your home to reduce the pests you currently have. We also apply a powerful barrier around your home to keep pests out.",
      },
      {
        title: "What to Expect After Your First Service",
        text: "After your initial service, it is possible that you might see a slight increase in pest activity because they're being flushed out of hiding. Our pest control methods, products and technologies are highly effective and always pet and human-friendly.",
      },
      {
        title: "Our Goal: Your Complete Satisfaction",
        text: "No need to put up with pests - put them to rest with Dead Bug Edwards.",
      },
    ],
    bullets: [
      "Quarterly recurring service plans",
      "One-time / as-needed visits",
      "Pet- and family-safe products",
      "Interior + exterior barrier treatments",
      "Nest and entry-point elimination",
      "Free re-treats between scheduled visits",
    ],
  },
  {
    slug: "rodent",
    icon: "fa-shield-cat",
    title: "Rodent Control",
    tag: "Exclusion + Removal",
    blurb: "Seal entry points, eliminate the colony, and prevent return visits with monitored exclusion.",
    img: "https://customer-assets.emergentagent.com/job_deadbug-leads/artifacts/jsi9pg5r_pexels-ralph-407274-7164046.jpg",
    heroHeadline: "Rodent Control",
    heroSub: "Rats and mice don't just gross people out - they damage property and spread disease.",
    intro: "Rodents chew wiring, ruin insulation, contaminate food and carry more than 35 diseases. And with a single pair capable of producing 2,000 offspring per year, one small sighting rarely stays small. Dead Bug Edwards treats rodent problems at the source - not just where they show up.",
    sections: [
      {
        title: "Inspection First",
        text: "Our technicians inspect attics, crawl spaces, garages, kitchens and exterior walls to identify entry points, runways, nesting sites and food sources. We hand you a written plan before any work begins.",
      },
      {
        title: "Exclusion + Elimination",
        text: "We seal every accessible entry point (rodents can squeeze through a hole the size of a dime) and combine trapping, baiting and monitoring stations to eliminate the active population. Then we return to verify and refresh.",
      },
      {
        title: "Long-Term Protection",
        text: "Ongoing exterior stations and quarterly checks keep new rodents from re-establishing. No need to put up with pests - put them to rest with Dead Bug Edwards.",
      },
    ],
    bullets: [
      "Attic & crawl-space inspection",
      "Full-property exclusion (seal entry points)",
      "Snap-trap and tamper-resistant bait stations",
      "Sanitation and droppings clean-up guidance",
      "Ongoing monitoring stations",
      "Rats, roof rats, mice and squirrels",
    ],
  },
  {
    slug: "marine",
    icon: "fa-sailboat",
    title: "Marine Pest Control",
    tag: "Boats & Yachts",
    blurb: "Specialized treatments to keep your boat, yacht or watercraft pest-free and dockside ready.",
    img: "https://customer-assets-cm19k8pv.emergentagent.net/job_deadbug-leads/artifacts/d4csyhgd_pexels-noble-mathew-126487-14595984.webp",
    heroHeadline: "Marine Pest Control",
    heroSub: "The company the pros rely on for boats, yachts and watercraft.",
    intro: "Dead Bug Edwards leads the industry in providing a full range of services to all types of marine vessels. From pest control to termite infestations, rely on our company that the pros rely on in the marine industry. No job is too big or too small - and every job is handled with care to protect your boat from those nasty invaders who are not welcomed on board.",
    sections: [
      {
        title: "Pests Don't Skip Water",
        text: "You might think you're exempt from pest problems out on the water - but roaches can sneak aboard inside deliveries or belongings. Wood-destroying organisms such as termites and powder post beetles can also be a major problem for boat owners. In fact, termites in boats can cause catastrophic damage if left untreated.",
      },
      {
        title: "Specialized Boat & Yacht Treatments",
        text: "At Dead Bug Edwards, we specialize in boat pest control and marine pest control and are equipped to help owners eliminate onboard insects. Our job is to eliminate roaches, ants, spiders, and silverfish among other nuisance and destructive pests.",
      },
      {
        title: "Trusted by the Marine Industry",
        text: "Boat yards, captains and yacht managers across South Florida call us first. No need to put up with pests - put them to rest with Dead Bug Edwards.",
      },
    ],
    bullets: [
      "Roach, ant, spider and silverfish treatments",
      "Termite and powder post beetle service",
      "Dockside and hauled-out service options",
      "Marine-friendly product selection",
      "Yachts, sport-fish, sail and commercial vessels",
      "Boatyard and marina programs",
    ],
  },
];

export const SERVICE_AREAS = [
  "Plantation", "Fort Lauderdale", "Weston", "Davie", "Sunrise",
  "Pembroke Pines", "Miramar", "Coral Springs", "Hollywood", "Miami",
  "Boca Raton", "Delray Beach", "Deerfield Beach", "Pompano Beach", "Coconut Creek",
];

export const TESTIMONIALS = [
  {
    quote: "Dead Bug Edwards saved our 1960s home from a massive termite problem. Three generations of my family have trusted them - and now so do I.",
    name: "Michelle R.",
    location: "Plantation, FL",
  },
  {
    quote: "They treat our restaurant like clockwork. Discreet visits, real documentation for inspections, zero issues in 4 years.",
    name: "Daniel P.",
    location: "Fort Lauderdale, FL",
  },
  {
    quote: "Professional, fair pricing, and they actually picked up the phone on a Saturday. Rare these days.",
    name: "Kayla T.",
    location: "Weston, FL",
  },
  {
    quote: "Been calling Dead Bug for over 20 years. Bob built this company right - and the team today still honors that.",
    name: "George A.",
    location: "Davie, FL",
  },
];
